/* global $, Foundation */
/* eslint-disable react-intl/string-is-marked-for-translation */
import { TimelineMax, Power4 } from 'gsap';
import 'gsap/ScrollToPlugin';

import { createElement, Component } from 'rlink-react';
import themeable from 'rlink-theme/themeable';

import ScrollMagic from 'helpers/importers/ScrollMagic';
import scrollLock from 'helpers/scrolling/scrollLock';
import scrollToSection from 'helpers/scrolling/scrollToSection';
import menuScene from 'helpers/scenes/menuScene';
import contentLoader from 'helpers/contentLoader';
import IconRelicLogo from 'components/svg/iconRelicLogo'

export default class HeaderNav extends Component {
  highlightActiveLink (hash) {
    $('#main-menu li').removeClass('active');
    $('#main-menu li').each((_index, value) => {
      let item = $(value).find('a').attr('href').replace('/', '');
      if (item === hash) {
        $(value).addClass('active');
      } else {
        $(value).removeClass('active');
      }
    });
  }

  initialize () {
    this.timelineObj = new TimelineMax({ paused: true })
      .fromTo(Foundation.utils.S('.top-bar-section'), 0.5, { autoAlpha: 0 }, { autoAlpha: 1 })
      .staggerFromTo(Foundation.utils.S('#main-menu li a'), 0.5, { y: -50, scale: 0.3, autoAlpha: 0 }, { y: 0, scale: 1, autoAlpha: 1, ease: Power4.easeOut }, 0.08, '-=0.5');
    this.highlightActiveLink(location.hash);

    $(window).on('hashchange', e => {
      e.preventDefault();
      if (window.hashTrack) {
        let hash = location.hash;
        this.highlightActiveLink(hash);
        scrollToSection(hash, false, false, 1);
      }
    });

    $(document).on('click.fndtn.topbar', '.toggle-topbar', e => {
      e.preventDefault();
      Foundation.libs.topbar.toggle();
      let hash = location.hash;
      this.highlightActiveLink(hash);
      if (Foundation.utils.S('.top-bar').hasClass('expanded')) {
        Foundation.utils.S('body').addClass('topbar-expanded');
        scrollLock(false);
        this.timelineObj.timeScale(2).play();
      } else {
        Foundation.utils.S('body').removeClass('topbar-expanded');
        this.timelineObj.timeScale(2).reverse();
        scrollLock(false);
      }
    });

    let _self = this;
    $('#main-menu li a').bind('click', 'a[href^=#]', e => {
      e.preventDefault();
      $('body').removeClass('noScroll');
      let id = $(e.target).attr('href').replace('/', '');
      if ($(id).length > 0) {
        window.hashTrack = true;
        scrollToSection(id, true, false, 1);
      }
      this.timelineObj.timeScale(2).reverse();
      Foundation.utils.S('body').removeClass('topbar-expanded');
      Foundation.libs.topbar.toggle();
    });
  }

  componentDidMount () {
    this.clientWidth = 0;
    this.clientHeight = 0;
    if (typeof ScrollMagic !== 'undefined') {
      let scrollController = new ScrollMagic.Controller({ loglevel: 0, addIndicators: false });
      scrollController.enabled(true);
      this.initialize();
      menuScene(scrollController);
    }
  }

  render () {
    return (
      <div>
        <div className="sticky">
          <nav className="top-bar" data-topbar data-options="is_hover:false; scrolltop:false; mobile_show_parent_link:true">
            <ul className="title-area">
              <li className="name">
                <a href="/" rel="home" title="Relic Entertainment Home" className="active">
                  <IconRelicLogo className="logo" />
                </a>
              </li>
              <li className="toggle-topbar menu-icon">
                <a href="#"><span /></a>
              </li>
            </ul>
            <section className="top-bar-section">
              <ul id="main-menu" className="main-nav right">
                <li className="first leaf" title="">
                  <a href="/#franchises" title="" className="active">Franchises</a>
                </li>
                <li className="leaf" title="">
                  <a href="/#studio" title="" className="active">The Studio</a>
                </li>
                <li className="leaf" title="">
                  <a href="/#history" title="" className="active">History</a>
                </li>
                <li className="last leaf" title="">
                  <a href="/#careers" title="" className="active">Careers</a>
                </li>
              </ul>
            </section>
          </nav>
        </div>

        <section className="l-header-region row" />
      </div>
    );
  }
}

themeable(HeaderNav, {
  classes: [
    'HeaderNavContainer',
  ],
});



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/HeaderNav.jsx